import { AgenciesWithPrimary } from "../../../general/src/AgenciesWithPrimary";
import { DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutCallinScriptUsers extends Layout {
    agenciesWithPrimary: AgenciesWithPrimary;
    sourceAgencyLink: DataSource;
    sourceCallinScriptTemplate: DataSource;
}
